export default __webpack_public_path__ + "static/test_tom_4-f603ccec7c96e619d6d50bdbed07193c.png";